import { Suspense, useEffect } from 'react';
import { Routes } from 'react-router-dom';

import { useAppDispatch } from '~/hooks/store';
import { Routes as AppRoutes } from '~/routes';
import { me } from '~/store/admin/actions';

export const App = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const init = async () => {
      await dispatch(me());

      removeRootPreloader();
    };

    void init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const removeRootPreloader = () => {
    const preloadingScreen: HTMLElement | null = document.querySelector('.main-preloader');

    if (preloadingScreen) {
      setTimeout(() => {
        preloadingScreen.style.opacity = '0';
        preloadingScreen.style.visibility = 'hidden';
        preloadingScreen.style.pointerEvents = 'none';
      }, 500);
      setTimeout(() => {
        document.querySelector('.main-preloader')?.remove();
      }, 1000);
    }
  };

  return (
    <Suspense fallback={null}>
      <Routes>{AppRoutes}</Routes>
    </Suspense>
  );
};
